import styled from 'styled-components';
import { ScEmptyGameCardContainer } from '@/modules/game/components/GameCardFactory/EmptyGameCard/styled';
import { device } from '@/styles/helpers';

export const ScGamesList = styled.div<{
  isFullScreen: boolean;
}>`
  &:not(:last-child) {
    margin-bottom: 32px;
  }

  ${ScEmptyGameCardContainer} {
    min-width: 0;
  }

  .title {
    line-height: 24px;
    margin-bottom: 8px;
  }

  .empty-list {
    height: ${({ isFullScreen }) => (isFullScreen ? '100%' : '54px')};
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
  }

  .list {
    width: 100%;
    display: grid;
    grid-template-columns: ${({ isFullScreen }) =>
      isFullScreen ? 'repeat(4, 1fr)' : 'repeat(5, 1fr)'};
    gap: 8px;
    list-style: none;

    li {
      height: ${({ isFullScreen }) => (isFullScreen ? '100%' : '54px')};
      width: ${({ isFullScreen }) => (isFullScreen ? '100%' : '54px')};
    }

    .show-more__btn {
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${({ theme }) => theme.blackColor};
      border-radius: 8px;
      padding-top: 100%;

      @media (${device.mobile}) {
        background: ${({ theme }) => theme.grayLightColor};
      }

      cursor: pointer;
      position: relative;

      font-size: 14px;
      font-weight: 700;
      line-height: 16px;
      letter-spacing: 0.14px;
      text-transform: uppercase;
      text-align: center;
      color: ${({ theme }) => theme.whiteColor};

      &.de,
      &.fr-ca,
      &.fr-ch {
        font-size: 11px;
      }

      .text {
        position: absolute;
        inset: 0;
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        padding: 20px;
      }

      @media (hover: hover) {
        &:hover {
          color: ${({ theme }) => theme.whiteColor};
        }
      }
    }
  }
`;
